import { useMemo } from 'react';

export const useComponentWillMount = (func: VoidFunction) => {
  useMemo(func, []);
};
